const Settings = require('./domain/Settings'),
	adManager = require('./services/adManager'),
	breakpoints = require('./services/breakpoints'),
	sizeMappings = require('./services/sizeMappings'),
	slotManager = require('./services/slotManager'),
	lazyLoadService = require('./services/lazyLoadService'),
	targeting = require('./services/targeting');

async function init(config) {
	performance.mark('advert - xandr - initialisation - start');

	const settings = new Settings(config);

	await lazyLoadService.init(settings);
	await breakpoints.init(settings);
	await targeting.init(settings);
	await sizeMappings.init(settings); // Depends on breakpoints
	await adManager.init(settings); // Depends on sizeMappings & breakpoints
	await slotManager.init(settings); // Depends on ad manager

	performance.mark('advert - xandr - initialisation - end');
}

module.exports = {
	init,
	'actions': {
		'loadSlot': slotManager.loadSlot,
		'getSlot': slotManager.getSlot,
		'getSlots': slotManager.getSlots,
		'getCurrentBreakpoint': breakpoints.getCurrentBreakpoint,
		'getBreakpoints': breakpoints.getBreakpoints,
		'getSizeMapping': sizeMappings.getSizeMapping,
		'getPageTargeting': targeting.getPageTargeting,
		'getSlotTargeting': targeting.getSlotTargeting
	}
};
